import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "regenerator-runtime/runtime";

declare var appName: string

/*const supportsContainerQueries = "container" in document.documentElement.style;
if (!supportsContainerQueries) {
    import("container-query-polyfill");
}*/

if(process && process.env.NODE_ENV === 'development'){
  //@ts-ignore
  global.appName = "appName";
  //@ts-ignore
  global.serviceName = "serviceName";
  //@ts-ignore
  global.tenant = {
    tint:'#00704A',
    displayName:'Starbucks',
    logoUrl:'https://upload.wikimedia.org/wikipedia/fr/d/d3/Starbucks_Corporation_Logo_2011.svg'
  };
  //@ts-ignore
  global.packageVersions = {};
  //@ts-ignore
  global.user = {
    firstName:'John',
    lastName:'Doe',
    email:'john.doe@gmail.com'
  };
  //@ts-ignore
  global.languages = ["fr"];

  //@ts-ignore
  //global.aumlContent = import('./devApp.auml').then(v => {return v});

  global.aumlContent = `<Application Type="SPA">
      <Application.Imports>
          <Import Namespace="e" Source="@echino/ui.component"/>
    </Application.Imports>
      <e:PageLayout Tint="{_tenant.tint}">
          <e:PageLayout.Menu>
              <e:NavigationMenuBrand Name="{_tenant.displayName}" LogoURL="{_tenant.logoUrl}" To="https://www.starbucks.ch" />
              <e:NavigationMenuProfile 
                  Name="{_user.firstName} {_user.lastName}" 
                  Description="{_user.email}"
                  PhotoURL="https://www.pngall.com/wp-content/uploads/5/Profile-PNG-File.png"/>
              
              <e:NavigationMenuItem Title="Home" Icon="fad fa-users" To="/home"/>
              <e:NavigationMenuItem Title="Page 1" Icon="fad fa-key" To="/page1"/>
            
        
          </e:PageLayout.Menu>
          <e:PageLayout.Content>
              <e:ContentStack>
          <e:Layout ContentStack.RoutePath="/home">
                      <e:Label Text="Home" />
                  </e:Layout>
          
                  <e:Layout ContentStack.RoutePath="/page1">
                      <e:Label Text="Page 1" />
                  </e:Layout>
              </e:ContentStack>
          </e:PageLayout.Content>
      </e:PageLayout>
    </Application>`

}


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

const updateHandler = (registration: ServiceWorkerRegistration) => {
    if (window.confirm("Update available. Do you want to reload?")) {
        window.location.reload();
    }
};

// Now handled in spaRender
/*
// Listen to notifications from the service worker
navigator.serviceWorker.onmessage = (event) => {
    if (event.data && event.data.type === 'PUSH_NOTIFICATION') {

        //TODO Callbacks

        console.log(event.data);

    }
};
*/

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
/*
serviceWorker.register({
    onUpdate: updateHandler,
});
*/
//serviceWorker.unregister();

serviceWorker.register(appName);
